module.exports = __webpack_public_path__ + "img/供餐-2.9fb20e3a.jpg";